import { HeaderMenu } from '@app/enums/_index';
import { environment } from '@environments/environment';

/**
 * Static User Menu links used by the header after user is signed in
 */
const USERMENU = {
  usermenu: [
    {
      name: HeaderMenu.MY_DASHBOARD,
      routerLink: '/dashboard',
      clickEvent: false,
    },
    {
      name: HeaderMenu.EDIT_PROFILE,
      routerLink: `${environment.docebo.url}/learn/my-profile`,
      clickEvent: false,
    },
    {
      name: HeaderMenu.CHANGE_PASSWORD,
      routerLink: 'https://apps.genesys.com/pcodebroker/resetPcode.aspx',
      clickEvent: false,
    },
    /* {
      name: HeaderMenu.MESSAGES,
      routerLink: '/message-inbox',
      clickEvent: false,
      displayInboxCount: true,
    },*/
    {
      name: HeaderMenu.SIGN_OUT,
      routerLink: '',
      clickEvent: true,
    },
  ],
};

export default USERMENU;
